import { useToast } from '@dc-shared-web/components/shadcn/use-toast'
import { useFSTrackEvent } from '@dc-shared-web/hooks/api/analytic'
import {
  deleteProject,
  DeleteProjectParams,
} from '@dc-shared-web/hooks/api/project/deleteProject'
import { Project } from '@dc-shared-web/hooks/api/project/types'
import { FS } from '@dc-shared-web/lib/trackingConstants'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useMutation, useQueryClient } from 'react-query'
import { Folder } from '@dc-shared-web/hooks/api/folder/types'

export const useDeleteProject = (params: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const apiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()
  const { toast } = useToast()
  const { trackEvent } = useFSTrackEvent()

  return useMutation(
    (mutationParams: DeleteProjectParams) =>
      deleteProject(apiClient, mutationParams),
    {
      onSuccess: async () => {
        trackEvent(FS.PROJECT_DELETED)

        await Promise.allSettled([
          queryClient.invalidateQueries<Project[]>(['projects']),
          queryClient.invalidateQueries<Folder[]>(['folders', 'list']),
          queryClient.invalidateQueries(['folder']),
          queryClient.invalidateQueries(['project']),
        ])

        params.onSuccess?.()
      },
      onError: () => {
        toast({
          variant: 'error',
          title: 'Error deleting project',
          description: 'If the issue persists, please contact support.',
        })
      },
    }
  )
}
